import ExecutionContext from '../../ExecutionContext';
import type { GtmPageStatsViewModel } from '../GtmPageStats/GtmPageStatsViewModel.csharp';
import type { GoogleTagManagerData, GoogleTagManagerProperties } from './GoogleTagManagerModels';

type DataLayerModel = GoogleTagManagerData | GoogleTagManagerProperties;

export class GtmEventsBase {
    public static pushGtmPageStats = (gtmPageStatsViewModel: GtmPageStatsViewModel) => {
        GtmEventsBase.push(gtmPageStatsViewModel.properties);
    };

    public static pushEvent = (eventName: string, payLoad: GoogleTagManagerProperties = []) => {
        GtmEventsBase.push({ event: eventName, ...payLoad });
    };

    protected static push(data: DataLayerModel) {
        if (ExecutionContext.IsServerSide()) {
            return;
        }

        const { dataLayer } = window as any;
        dataLayer && dataLayer.push(data);
    }
}
